/**
 * Created by zhangkaili on 20180424.
 */

import $ from 'jquery';
import maple from 'maple';

import {request} from '../http';
import domain from '../domain';

const pushserv = function(){
    if(domain.env === 'online'){
        this.domain = "//pushserv.51tiangou.com";
    }else{
        this.domain = "//pushserv." + domain.env + ".66buy.com.cn";
    }
};

/**
* 周期购券列表和复购推荐商品
* @param  {[type]} cycleId [周期购的历史快照参数]
* @return {[type]} couponList [券列表]
* @return {[type]} cycleProductList [复购推荐商品]
*/
pushserv.prototype.query = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/cycle/query', params);
};

pushserv.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    request(params);
};

// 站内信
pushserv.prototype.stationMail = function (params) {
    var that = this;
    params.type = 'GET';
    that._serviceAjaxCom('/open/wtf-adv/list', params);
};

export default new pushserv();